import React from 'react'

import Button from '../../packages/kiti/components/actions/Button'
import { Grid } from '../../packages/kiti/components/structure/Grid'

const ToggleButtonGroupInput = ({ options = [], value, onChange, ...props }) => {
  return (
    <Grid gap={0.5}>
      {options.map(option => {
        const active = value === option.value

        return (
          <Button
            key={option.value}
            transparent={!active}
            color={active ? option.color : 'dark4'}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Button>
        )
      })}
    </Grid>
  )
}

export default ToggleButtonGroupInput
